import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ConfirmDialogVM } from './ConfirmDialogVM';
import { observer } from 'mobx-react';

interface IConfirmDialogProps {
  vm: ConfirmDialogVM;
}

export const ConfirmDialog = observer(function ConfirmDialog(props: IConfirmDialogProps) {
  const vm = props.vm;
  return (
    <Modal className="eft-action-modal" isOpen={vm.isOpen}>
      <ModalHeader>
        <strong>{vm.title}</strong>
      </ModalHeader>
      <ModalBody>
        <p>{vm.message}</p>
      </ModalBody>
      <ModalFooter>
        <button className="usa-button usa-button--outline" onClick={vm.cancel}>
          Close
        </button>
        <button className="usa-button" onClick={vm.accept}>
          Confirm
        </button>
      </ModalFooter>
    </Modal>
  );
});
